import type { AppId } from "../lib/types";

interface Props {
  appId: AppId;
  setAppId: (id: AppId) => void;
  viewMode: "customer" | "internal";
  setViewMode: (m: "customer" | "internal") => void;
}

const NAV = ["Send + receive", "Services", "Locations", "Help"];

export function Header({ appId, setAppId, viewMode, setViewMode }: Props) {
  return (
    <header className="bg-white border-b border-slate-100 sticky top-0 z-30">
      <div className="max-w-page mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-6">
        <a
          href="#"
          className="flex items-center gap-2 font-display font-bold text-slate-900 shrink-0"
        >
          <span className="bg-mg-red text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold">
            M
          </span>
          MoneyGram
        </a>
        <nav className="hidden lg:flex items-center gap-6 text-sm font-medium text-slate-700">
          {NAV.map((n) => (
            <a key={n} href="#" className="hover:text-slate-900">
              {n}
            </a>
          ))}
        </nav>
        <div className="flex-1" />
        <span aria-hidden className="hidden md:inline text-lg">
          🇺🇸
        </span>
        <div className="hidden md:flex items-center gap-3 text-sm">
          <a href="#" className="text-slate-700 hover:text-slate-900">
            Sign in
          </a>
          <a href="#" className="btn-cta">
            Sign up
          </a>
        </div>

        {/* Demo-only controls (would not ship to prod) */}
        <div className="flex items-center gap-2 pl-3 ml-3 border-l border-slate-200 text-xs">
          <select
            value={appId}
            onChange={(e) => setAppId(e.target.value as AppId)}
            className="bg-slate-100 border border-slate-200 rounded px-2 py-1"
            title="X-App-Id header"
          >
            <option value="mgo-web">mgo-web</option>
            <option value="mgo-ios">mgo-ios</option>
            <option value="mgo-android">mgo-android</option>
            <option value="stellar">stellar</option>
            <option value="agent-portal">agent-portal</option>
          </select>
          <div className="inline-flex rounded-full border border-slate-200 overflow-hidden">
            {(["customer", "internal"] as const).map((v) => (
              <button
                key={v}
                onClick={() => setViewMode(v)}
                className={`px-2.5 py-1 ${
                  viewMode === v
                    ? "bg-slate-900 text-white"
                    : "text-slate-600"
                }`}
              >
                {v}
              </button>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}
